import React, { useEffect } from 'react';
import { BrowserRouter } from "react-router-dom";
import * as ReactDOMClient from 'react-dom/client';
import {
  CircularProgress,
} from "@mui/material"

import App from './App';
import "./index.css";

// Basic Redux Store Imports
import { applyMiddleware, compose, createStore } from 'redux';

import { SnackbarProvider, useSnackbar } from 'notistack';

import { Provider, useSelector } from 'react-redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers'

// For Adding Firebase middleware 
import { getFirebase, isLoaded, ReactReduxFirebaseProvider } from 'react-redux-firebase';
import firebaseConfig, { auth } from './utils/firebaseConfig'


// Chrome Redux DevTools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(
  applyMiddleware(thunk.withExtraArgument({getFirebase}))
))

// Props to pass in ReactReduxFirebaseProvider - Higher Order Provider Component
const rrfProps = {
  firebase: firebaseConfig,
  config: {},  // for firestore
  dispatch: store.dispatch
}

// Get Authentication Status of Load before rendering children
function AuthIsLoaded({ children }) {
  const auth = useSelector(state => state.firebase.auth)
 

  if (!isLoaded(auth)) return (
      <CircularProgress style={{ display: "flex", position: "absolute", top: "50%", left: "50%", marginRight: "-50%", transform: "translate(-50%, -50%)" }} />
  );

  return children
  
}




const root = ReactDOMClient.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>


    <ReactReduxFirebaseProvider {...rrfProps}>
      <AuthIsLoaded>
      {/* <SnackbarProvider maxSnack={3}> */}
    <App />
    {/* </SnackbarProvider> */}
  </AuthIsLoaded>
    </ReactReduxFirebaseProvider>


  </Provider>
);

